import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { Grid } from 'gu-ui-kit'
import { BackButton, Langs, Logo } from 'layouts/AuthLayout/subcomponents'
import { ROUTES } from 'constants/routes'
import { useSelector } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import styles from 'layouts/AuthLayout/AuthLayout.module.scss'
import { useLocation } from 'react-router-dom'
import { ReactComponent as ContentBgSVG } from 'images/auth/bg.svg'
import clsx from 'clsx'

const AuthLayout = ({ children = null }) => {
  const { i18n } = useSelector(({ app }) => app)
  const pathGen = useGeneratePathI18n()
  const location = useLocation()

  const isLoginOrRegisterPage = useMemo(
    () =>
      [pathGen(ROUTES.AUTH_LOGIN), pathGen(ROUTES.AUTH_REGISTRATION)].includes(location.pathname),
    [location],
  )

  const url = useMemo(() => {
    if (isLoginOrRegisterPage) {
      return pathGen(ROUTES.MAIN)
    }
    return pathGen(ROUTES.AUTH_LOGIN)
  }, [i18n, isLoginOrRegisterPage])

  return (
    <Grid className={styles['layout']}>
      <div className={styles['layout__wrapper-backgrounds']}>
        <div className={styles['layout__bgs']}>
          <div className={clsx(styles['layout__bg'], styles['layout__bg_1'])} />
          <div className={clsx(styles['layout__bg'], styles['layout__bg_2'])} />
          <div className={clsx(styles['layout__bg'], styles['layout__bg_3'])} />
        </div>

        <Grid
          alignItems={'center'}
          direction={'column'}
          className={styles['layout__content-bg']}
        >
          <ContentBgSVG />
        </Grid>
      </div>
      <Grid
        alignItems={'center'}
        justifyContent={'center'}
        direction={'column'}
        wrap={false}
        fluid
        className={styles['layout__wrapper-content']}
      >
        <div className={styles['layout__content']}>
          <Grid
            className={'margin-bottom-40'}
            justifyContent={'space-between'}
            alignItems={'center'}
            wrap={false}
          >
            <Grid>
              <BackButton url={url} />
            </Grid>
            <Grid justifyContent={'center'}>
              <Logo />
            </Grid>
            <Grid justifyContent={'end'}>
              <Grid
                alignItems={'center'}
                justifyContent={'end'}
                wrap={false}
                className={styles['layout__lang']}
                fluid={false}
              >
                <Langs />
              </Grid>
            </Grid>
          </Grid>
          <div>{children}</div>
        </div>
      </Grid>
    </Grid>
  )
}

AuthLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
}

export default AuthLayout
